declare namespace $ {

	type $mol_button__hint_shm_media_1 = $mol_type_enforce<
		ReturnType< $shm_media['preview_hint'] >
		,
		ReturnType< $mol_button['hint'] >
	>
	type $mol_button__sub_shm_media_2 = $mol_type_enforce<
		ReturnType< $shm_media['preview_content'] >
		,
		ReturnType< $mol_button['sub'] >
	>
	type $mol_button__click_shm_media_3 = $mol_type_enforce<
		ReturnType< $shm_media['open'] >
		,
		ReturnType< $mol_button['click'] >
	>
	type $mol_view__sub_shm_media_4 = $mol_type_enforce<
		ReturnType< $shm_media['full_content'] >
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_button_minor__hint_shm_media_5 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_button_minor['hint'] >
	>
	type $mol_button_minor__sub_shm_media_6 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_button_minor['sub'] >
	>
	type $mol_button_minor__click_shm_media_7 = $mol_type_enforce<
		ReturnType< $shm_media['close'] >
		,
		ReturnType< $mol_button_minor['click'] >
	>
	type $mol_view__event_shm_media_8 = $mol_type_enforce<
		({ 
			click( next?: ReturnType< $shm_media['close'] > ): ReturnType< $shm_media['close'] >,
		}) 
		,
		ReturnType< $mol_view['event'] >
	>
	type $mol_view__sub_shm_media_9 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_view['sub'] >
	>
	type $mol_image__uri_shm_media_10 = $mol_type_enforce<
		ReturnType< $shm_media['uri'] >
		,
		ReturnType< $mol_image['uri'] >
	>
	type $mol_video_player__uri_shm_media_11 = $mol_type_enforce<
		ReturnType< $shm_media['uri'] >
		,
		ReturnType< $mol_video_player['uri'] >
	>
	type $mol_video_player__autoplay_shm_media_12 = $mol_type_enforce<
		boolean
		,
		ReturnType< $mol_video_player['autoplay'] >
	>
	type $mol_video_player__controls_shm_media_13 = $mol_type_enforce<
		boolean
		,
		ReturnType< $mol_video_player['controls'] >
	>
	type $mol_video_player__muted_shm_media_14 = $mol_type_enforce<
		boolean
		,
		ReturnType< $mol_video_player['muted'] >
	>
	type $mol_image__uri_shm_media_15 = $mol_type_enforce<
		ReturnType< $shm_media['uri'] >
		,
		ReturnType< $mol_image['uri'] >
	>
	type $mol_video_player__uri_shm_media_16 = $mol_type_enforce<
		ReturnType< $shm_media['uri'] >
		,
		ReturnType< $mol_video_player['uri'] >
	>
	type $mol_video_player__autoplay_shm_media_17 = $mol_type_enforce<
		boolean
		,
		ReturnType< $mol_video_player['autoplay'] >
	>
	type $mol_video_player__controls_shm_media_18 = $mol_type_enforce<
		boolean
		,
		ReturnType< $mol_video_player['controls'] >
	>
	type $mol_video_player__muted_shm_media_19 = $mol_type_enforce<
		boolean
		,
		ReturnType< $mol_video_player['muted'] >
	>
	export class $shm_media extends $mol_pop {
		preview_hint( ): string
		preview_content( ): readonly(any)[]
		open( next?: any ): any
		Preview( ): $mol_button
		close( next?: any ): any
		full_content( ): readonly(any)[]
		Full( ): $mol_view
		Close_icon( ): $mol_icon_close
		Close( ): $mol_button_minor
		Overlay( ): $mol_view
		uri( ): string
		kind( ): string
		Anchor( ): ReturnType< $shm_media['Preview'] >
		bubble_content( ): readonly(any)[]
		Preview_image( ): $mol_image
		Preview_video( ): $mol_video_player
		Full_image( ): $mol_image
		Full_video( ): $mol_video_player
	}
	
}

//# sourceMappingURL=media.view.tree.d.ts.map